import React from 'react';
import axios from 'axios';
import { getConfig } from "@root/config/config";
import { useSelectSlice } from "@common/redux/selectors/useSelectSlice";
import { authSlice } from "@common/redux/slices/auth.slice";
import { AuthModal } from "@kursk/components/Layout/AuthModal/AuthModal";
import { ENABLED_FAVORITES_ENTITY_TYPES, FAVORITES_ENTITY_TYPES } from "@common/redux/types/favorites";
import { addToFavorite, removeFromFavorite } from "@common/redux/slices/favorites/favorites.slice";
import { notificationPush } from "@common/redux/slices/notification.slice";
import { useDispatch } from "react-redux";
import { useDispatchThunk } from "@common/redux/dispatchThunk";
import { EntityType } from "@common/redux/types/common";
import { FavoritesButton } from "@kursk/components/ui/FavoritesButton/components/FavoritesButton/FavoritesButton";
import { api } from "@common/urls";

const config = getConfig();

const isAvailableForCurrentRegion = config.features.favorites.enabled;

type TProps = {
  entityId: string;
  entityType: EntityType;
}

export const EntityCardFavoritesButton = ({
  entityId,
  entityType,
}: TProps) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [isOpenAuthModal, setIsOpenAuthModal] = React.useState(false);
  const [isFavorite, setIsFavorite] = React.useState(false);
  const dispatch = useDispatch();
  const dispatchThunk = useDispatchThunk();
  const { user } = useSelectSlice(authSlice);

  const isFeatureEnabled = isAvailableForCurrentRegion && ENABLED_FAVORITES_ENTITY_TYPES.includes(entityType);

  const checkIsFavorite = async () => {
    const response = await axios.put(
      api.favorites.check(),
      { entityId, entityType: FAVORITES_ENTITY_TYPES[entityType] }
    );
    setIsFavorite(!!response?.data?.result);
  }

  React.useEffect(() => {
    if (user && isFeatureEnabled) {
      checkIsFavorite();
    }
  }, [entityId, user?._id, isFeatureEnabled]);

  const onAddToFavorite = async () => {
    setIsLoading(true);

    if (!isFavorite) {
      await dispatchThunk(addToFavorite({ entityId, entityType: FAVORITES_ENTITY_TYPES[entityType] }) as any);
      dispatch(notificationPush({ content: 'Добавлено в избранное', type: 'success' }));
      setIsFavorite(true);
    } else {
      await dispatchThunk(removeFromFavorite({ entityId, entityType: FAVORITES_ENTITY_TYPES[entityType] }) as any)
      dispatch(notificationPush({ content: 'Удалено из избранного', type: 'success' }));
      setIsFavorite(false);
    }

    setIsLoading(false);
  }

  const openModal = () => {
    if (user) {
      onAddToFavorite();
    } else {
      setIsOpenAuthModal(true);
    }
  };


  return isFeatureEnabled ? (
    <>
      <AuthModal isOpen={isOpenAuthModal} setIsOpen={setIsOpenAuthModal}/>
      <FavoritesButton isFavorite={isFavorite} isLoading={isLoading} onClick={openModal} withoutBorder />
    </>
  ) : null;
};
